import React, { Component } from 'react';
import Translate from 'react-translate-component';
import { pathOr } from 'ramda';

import XMLFields from './XMLFields';

const fieldsXML = [
    { name: 'IntervMain.SotrName', label: 'SotrName' },
    { name: 'IntervMain.PersonalAppearance', label: 'PersonalAppearance' },
    { name: 'IntervMain.PersonalQualities', label: 'PersonalQualities' },
    { name: 'IntervMain.ProfessionalMotivation', label: 'ProfessionalMotivation' },
    { name: 'IntervMain.ProfessionalExperience', label: 'ProfessionalExperience' },
    { name: 'IntervMain.LanguageSkills', label: 'LanguageSkills' },
    { name: 'IntervMain.DifFromCV', label: 'DifFromCV' },
    { name: 'IntervMain.WantSalary', label: 'WantSalary' },
    { name: 'IntervMain.JobSearchHistory', label: 'JobSearchHistory' },
    { name: 'IntervMain.WherePresent', label: 'WherePresent' },
    { name: 'IntervMain.WhereEfficient', label: 'WhereEfficient' },
    { name: 'IntervMain.DopInfo', label: 'DopInfo' },
    { name: 'IntervMain.AlsoParticipated', label: 'AlsoParticipated' },
];

export default class EmplInterview extends Component {
    componentDidMount() {
        const { event } = this.props;

        if (event && event.details) {
            const { details } = event;

            setTimeout(() => {
                this.props.form.change('result.xmlbody.IntervMain.IntDate', details.eventDate);
                this.props.form.change('result.xmlbody.IntervMain.SotrKey', pathOr('', ['responsible', 0, 'id'], details));
                this.props.form.change('result.xmlbody.IntervMain.SotrName', pathOr('', ['responsible', 0, 'text'], details));
                this.props.form.change('result.xmlbody.IntervMain.CandKey', pathOr('', ['people', 0, 'id'], details));
                this.props.form.change('result.xmlbody.IntervMain.Candidate', pathOr('', ['people', 0, 'text'], details));
            }, 0);
        }
    }

    render() {
        const candidate = pathOr('', ['event', 'details', 'people', 0, 'text'], this.props);

        return (
            <div>
                <h3>
                    <Translate content="xml.PplInterv.Candidate" /> {candidate}
                </h3>

                <XMLFields fieldsXML={fieldsXML} translatePrefix="PplInterv" />
            </div>
        );
    }
}
